import React, { useState } from 'react'
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import useClipboard from "react-use-clipboard";

const Speech = () => {
    const [text, setText] = useState()
    const [isCopied, setCopied] = useClipboard(text);

    const StartListening = ()=> SpeechRecognition.startListening({ continuous: true, language: 'en-IN' })
    const {
        transcript,
        browserSupportsSpeechRecognition
      } = useSpeechRecognition();

      if (!browserSupportsSpeechRecognition) {
        return <span>Browser doesn't support speech recognition.</span>;
      }    
    
  return (
    <div>
        <div className='container'>
            <h2>Speech to Text Converter</h2>
            <br></br>
            <p>A react component </p>

            <div className="main-content" onClick={()=> setText(transcript)}>
                {transcript}
            </div>

            <div className="btn-style">
                <button onClick={setCopied}>{isCopied ? 'Copied' : 'Copy Text'}</button>
                <button onClick={StartListening}>Start Listening</button>
                <button onClick={SpeechRecognition.stopListening}>Stop Listening</button>
            </div>

        </div>
    </div>
  )
}

export default Speech